module.exports = __webpack_public_path__ + "img/c424f0d.png";